<template>
  <div>
    <v-container>
      <v-expansion-panels v-model="expandedPanels" multiple>
        <v-expansion-panel v-for="(caption, index) in captions" :key="index">
          <v-expansion-panel-title>
            <h4>{{ caption.title }}</h4>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <v-card outlined>
              <v-card-text>
                <!-- Caption Section -->
                <div>
                  <div class="caption-header">
                  <h3>Caption:</h3>
                  <v-btn fab icon small @click="copyText(caption.caption, CopyType.CAPTION)" class="fab-btn">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                  </div>
                  <p class="caption-text">
                    {{ caption.caption }}
                  </p>
                </div>
                <v-divider class="my-3"></v-divider>

                <!-- Hashtags Section -->
                <div>
                  <div class="caption-header">
                    <h3>Hashtags:</h3>
                    <v-btn fab icon small @click="copyText(caption.hashtags, CopyType.HASHTAG)" class="fab-btn">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </div>
                  <v-textarea
                    readonly
                    :value="formatHashtags(caption.hashtags)"
                    outlined
                    rows="2"
                    class="mb-3"
                  ></v-textarea>
                </div>
              </v-card-text>
            </v-card>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
    <v-snackbar v-model="snackbar" :timeout="2000" color="success">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
  // import captions from '@/assets/post-captions.json';
  const CopyType = Object.freeze({
    CAPTION: 'Caption',
    HASHTAG: 'Hashtag'
  });
  export default {
    data() {
      return {
        CopyType,
        captions: [],
        expandedPanels: [0],
        previousMonth: '',
        currentMonth: '',
        targetType: '',
        snackbar: false,
        snackbarText: '',
      };
    },
    methods: {
      // Format hashtags as a single string
      formatHashtags(hashtags) {
        return hashtags.join(' ');
      },
      copyText(text, type) {
        navigator.clipboard.writeText(text).then(() => {
          // Show a toast/snackbar or notification when the text is copied
          this.snackbarText = `${type} copied to clipboard!`;
          this.snackbar = true;
        }).catch(err => {
          console.error('Failed to copy: ', err);
          this.snackbarText = 'Failed to copy text';
          this.snackbar = true;
        });
      },
      async loadScriptsBasedOnQuery() {
        const postCaptions = await import('@/assets/post-captions-current.json');
        this.captions = postCaptions.default; // dynamically load the USA scripts
        if(this.targetType === this.previousMonth) {
          const postCaptions = await import('@/assets/post-captions-previous.json');
          this.captions = postCaptions.default; // dynamically load the USA scripts
        }
      },
    },
  };
</script>
  
<style scoped>
  .caption-header {
    display: flex; /* Aligns the h3 and the button in a row */
    align-items: center; /* Vertically centers the items */
    justify-content: space-between;
    padding: 8px, 0;
  }
  .caption-text {
    white-space: pre-wrap;
    position: relative;
  }

  .fab-btn {
    /* position: absolute; */
    top: 0;
    right: 0;
    margin-right: 8px;
    z-index: 1;
  }

  .v-card-text {
    padding: 16px;
  }
  
  .v-expansion-panel-header {
    font-weight: bold;
    font-size: 1.2rem;
  }
  
  .v-expansion-panel {
    margin-bottom: 10px;
  }
  
  .v-textarea {
    background-color: #f5f5f5;
    border-radius: 4px;
    font-family: monospace;
  }
  
  .v-expansion-panels {
    margin-top: 20px;
  }
  
  h3 {
    margin-bottom: 8px;
  }
</style>
  